import { render, staticRenderFns } from "./ViewAssociates.vue?vue&type=template&id=434553d0&"
import script from "./ViewAssociates.vue?vue&type=script&lang=js&"
export * from "./ViewAssociates.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssociates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports